import {RatingStars} from '@frontend/components/RatingStars'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {DropdownDivider} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownDivider'
import {UserAvatar} from '../../../components/UserAvatar'
import {trans} from '../../../helpers'
import {useUserData} from '../../../hooks'
import {
    useAuthStore,
    useTopMenuStore,
} from '../../../stores'
import {CabinetMoneyEarnedCard} from '../../private/shared/cabinet_menu/CabinetMoneyEarnedCard'
import {CabinetUserReviewsButton} from '../../private/shared/cabinet_menu/CabinetUserReviewsButton'

// Данные профиля пользователя в выпадающем меню в заголовке страницы.
export function TopNavigationUserDropdownMenuUserInfo() {

    const user = useUserData()

    const initUserAuthModal = useAuthStore(
        state => state.initUserAuthModal
    )
    const topMenuAuthBlock = useTopMenuStore(
        state => state.authBlock
    )

    if (!user) {
        if (!topMenuAuthBlock) {
            return null
        }
        return (
            <>
                <div className="px-3 pb-2 d-flex gap-3 flex-row align-items-center">
                    <UserAvatar
                        userName={null}
                        fallbackContent={(
                            <img
                                src="/img/dotoku-short.svg"
                                alt=""
                                height={26}
                            />
                        )}
                        fallbackContentClassName="bg-light-gray lh-1 flex-center"
                    />
                    <Button
                        color="gray"
                        outline
                        onClick={() => initUserAuthModal()}
                    >
                        {trans().auth.login.do_login}
                    </Button>
                </div>
                <DropdownDivider />
            </>
        )
    }

    return (
        <>
            <div className="px-3 pb-2 d-flex gap-3 flex-row align-items-center">
                <UserAvatar userName={user.fullName} />
                <div className="d-flex flex-column align-items-stretch">
                    <div className="fw-700">
                        {user.fullName}
                    </div>
                    <div
                        className="flex-container-row my-1"
                        title={String(user.rating)}
                    >
                        <RatingStars
                            rating={user.rating}
                            starSize={20}
                            className="gap-0"
                        />
                    </div>
                    <CabinetUserReviewsButton className="p-0 align-self-start" />
                </div>
            </div>
            <CabinetMoneyEarnedCard className="mx-3 mb-2" />
            <DropdownDivider />
        </>
    )
}
